<template>
  <div class="language-selector">
    <div class="mobile-only menu-trigger" @click="toggleMenu">
      <span class="language-flag" :class="selectedLang?.flag"></span>
      <span class="menu-trigger__label">{{selectedLang?.name || 'English'}}</span>
      <span class="icon icon-chevron-down menu-trigger__arrow"></span>
    </div>
    <div class="locales-selector desktop-only" ref="localesDropdown">
      <div @click="toggleDropdown" class="flex">
        <span class="language-flag" :class="selectedLang?.flag"></span>
        <span class="text-body-1 fw-medium language-selector--lang">{{locale ? locale.toUpperCase() : 'EN'}}</span>
        <span class="icon icon-chevron-down"></span>
      </div>
      <div class="locales-dropdown p-overlaypanel" v-if="dropdown">
        <MobileMenuList :list="languages" :selectedOption="selectedLang" @change="selectLanguage"/>
      </div>
    </div>
    <ClientOnly fallback-tag="div">
      <LazyDialog
          v-model:visible="menuVisible"
          :showHeader="false"
          position="right"
          :block-scroll="true"
          :modal="true"
          :draggable="false"
          class="mobile-menu-dialog"
      >
        <template #container>
          <div class="mobile-menu-container">
            <div @click="menuVisible = false">
              <div class="pb-4 mobile-menu-dialog-header mobile-menu-dialog-header--return">
                <button>
                  <span class="icon icon-chevron-left color-blue"></span>
                </button>
                {{$t('Select language')}}
              </div>
            </div>
            <div>
              <MobileMenuList :list="languages" :selectedOption="selectedLang" @change="selectLanguage"/>
            </div>
          </div>
        </template>
      </LazyDialog>
    </ClientOnly>

  </div>
</template>
<script setup lang="ts">
const { setLocale, locales, locale } = useI18n()
import { useMobileDialog } from '@/composables/useMobileDialog';
import MobileMenuList from "~/components/SiteHeader/MobileMenuList.vue";
const { menuVisible, toggleMenu } = useMobileDialog();
const dropdown = ref(false)
const localesDropdown = ref(null)
const languages = [
  { code: 'en', language: 'en-US', name: 'English', flag: 'fi fi-us' },
  { code: 'es', language: 'es-ES', name: 'Spanish', flag: 'fi fi-es' },
  { code: 'de', language: 'de-DE', name: 'German', flag: 'fi fi-de' },
  { code: 'it', language: 'it-IT', name: 'Italian', flag: 'fi fi-it' },
  { code: 'pt', language: 'pt-PT', name: 'Portuguese', flag: 'fi fi-pt' },
  { code: 'ja', language: 'ja-JP', name: 'Japanese', flag: 'fi fi-jp' },
  { code: 'ru', language: 'ru-RU', name: 'Russian', flag: 'fi fi-ru' },
]


const selectedLang = computed(() =>
  languages.find(lang => lang.code === locale.value) || languages[0]
)

//methods
const selectLanguage = (lang: any) => {
  setLocale(lang.code)
  dropdown.value = false;
  menuVisible.value = false;
}

function toggleDropdown() {
  dropdown.value = !dropdown.value
}

function handleClickOutside(e: any) {
  const langDropdown = localesDropdown.value;
  if (e.target instanceof Element && langDropdown && !(langDropdown as any).contains(e.target)) {
    dropdown.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
})
</script>
<style lang="scss" scoped>
.language-selector {
  display: flex;
  align-items: center;
  cursor: pointer;

  .flex {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid var(--grey-border);
    transition: all 0.2s ease;

    &:hover {
      background: var(--light-grey);
    }
  }

  .language-flag {
    font-size: 14px;
    line-height: 1;
    border-radius: 2px;
    width: 18px;
  }

  .icon {
    font-size: 10px;
    display: flex;
    align-items: center;
    color: var(--dark-grey);
  }

  &--lang {
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
  }
}

.menu-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  .language-flag {
    font-size: 16px;
    line-height: 1;
    border-radius: 2px;
    width: 20px;
    flex-shrink: 0;
  }

  // Override .language-selector .icon (same specificity 0-2-0, wins by source order)
  .icon {
    font-size: 11px;
    color: var(--dark-grey-secondary);
    transform: rotate(-90deg);
    flex-shrink: 0;
  }

  &__label {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: var(--black);
  }
}

.locales-selector {
  position: relative;
  display: flex;
  align-items: center;
}

.locales-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 3000;
  min-width: 200px;
}
</style>
